export default "__VITE_ASSET__c49784bd__"